import {
  HOURS_PER_DAY,
  MILLISECONDS_PER_SECOND,
  ONE_HOUR,
  SECONDS_PER_MINUTE,
} from "@miplatform/constants";

export const getTotalMilliseconds = (
  seconds: number,
  minutes?: number,
  hours?: number,
  days?: number
): number => {
  let totalMilliseconds = seconds * MILLISECONDS_PER_SECOND;

  if (minutes) {
    totalMilliseconds += minutes * SECONDS_PER_MINUTE * MILLISECONDS_PER_SECOND;
  }

  if (hours) {
    totalMilliseconds +=
      hours * ONE_HOUR * SECONDS_PER_MINUTE * MILLISECONDS_PER_SECOND;
  }

  if (days) {
    totalMilliseconds +=
      days *
      HOURS_PER_DAY *
      ONE_HOUR *
      SECONDS_PER_MINUTE *
      MILLISECONDS_PER_SECOND;
  }

  return totalMilliseconds;
};
